module.exports = __webpack_public_path__ + "img/img2.eb11c14c.svg";